import type { EScholarshipStatus } from '@/shared/api/generated';
import { useGetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab } from '@/shared/api/generated';

import type {
  EnrollmentScholarshipStatus,
  ScholarshipDetail,
  ScholarshipEnrollmentStatus,
} from '../types/enrollment';

function mapScholarshipStatus(
  schoolDiscount: number | null | undefined,
): EnrollmentScholarshipStatus {
  if (!schoolDiscount || schoolDiscount <= 0) return 'none';
  return schoolDiscount >= 100 ? 'full' : 'partial';
}

const SCHOLARSHIP_ENROLLMENT_STATUS_MAP: Record<EScholarshipStatus, ScholarshipEnrollmentStatus> = {
  1: 'interested',
  2: 'in_process',
  3: 'scholarship_holder',
  4: 'refused',
  5: 'refused_interested',
  6: 'refused_potential',
};

function mapEnrollmentStatus(
  status: EScholarshipStatus | null | undefined,
): ScholarshipEnrollmentStatus | null {
  return status ? (SCHOLARSHIP_ENROLLMENT_STATUS_MAP[status] ?? null) : null;
}

/**
 * Hook para carregar a lista de bolsas de uma matrícula.
 * Retorna as bolsas mapeadas para o tipo interno `ScholarshipDetail`.
 *
 * @param enrollmentId - ID da matrícula
 * @returns Lista de bolsas e estado de loading/erro
 */
export function useEnrollmentScholarship(enrollmentId: number) {
  const { data, isLoading, isError } =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab(enrollmentId);

  const scholarships: readonly ScholarshipDetail[] = (data ?? []).map(
    (vm): ScholarshipDetail => ({
      ...vm,
      status: mapScholarshipStatus(vm.schoolDiscount),
      enrollmentStatus: mapEnrollmentStatus(vm.scholarshipStatus),
    }),
  );

  return { scholarships, isLoading, isError } as const;
}
